/** @note URL의 path를 관리하는 상수 */
export const PATH = {
  // 홈
  MAIN: '/',

  // 상품 관리
  PRODUCT: '/product',
  PRODUCT_REGISTER: '/product/register',
  PRODUCT_OPERATING: '/product/operating',
  PRODUCT_MAPPING: '/product/mapping',

  // 입고 관리
  RECEIVE: '/receive',
  RECEIVE_REQUESTS: '/receive/requests',
  RECEIVE_STATUS: '/receive/status',
  RECEIVE_REPORT: '/receive/report',

  // 재고 관리
  STOCK: '/stock',
  STOCK_SKU: '/stock/sku',
  STOCK_DATE: '/stock/date',
  STOCK_LEDGER: '/stock/ledger',
  STOCK_RELEASE: '/stock/release',

  // 정산 관리
  SETTLEMENT: '/settlement',
  SETTLEMENT_STORAGE: '/settlement/storage',

  // 주문 관리
  ORDER: '/order',
  ORDER_ORDERS: '/order/orders',

  // 반품 교환 관리
  CLAIM: '/claim',
  CLAIM_RETURN: '/claim/return',
  CLAIM_EXCHANGE: '/claim/exchange',

  // 배송 관리
  DELIVERY_AGENCY: '/delivery-agency',
  DELIVERY_AGENCY_STATUS: '/delivery-agency/status',
  DELIVERY_AGENCY_ORDER: '/delivery-agency/order',
  DELIVERY_AGENCY_TRACKING: '/delivery-agency/tracking',
  DELIVERY_AGENCY_OUTBOUND_UNIT: '/delivery-agency/outbound-unit',
  DELIVERY_AGENCY_REPORT: '/delivery-agency/report',

  // 화주사 관리
  VENDER: '/vender',
  VENDER_CONFIRM: '/vender/confirm',
  VENDER_SUPPLIER: '/vender/supplier',
  VENDER_MODIFY: '/vender/modify',

  // 인증 관련
  LOGIN: '/login',
  LOGOUT: '/logout',
  CHANGE_PASSWORD: '/change-password',
  FIND_ID: '/find-id',
  FIND_PASSWORD: '/find-password',
  TWO_FACTOR_AUTH: '/two-factor-auth',

  // 배송 권역 조회 (로그인 없이 외부 접근 가능 링크)
  DELIVERY_AREA_REFINE: '/delivery-area/refine',
} as const;

/** @note 로그인 없이 접근 가능한 공개 경로 */
export const PUBLIC_PATHS: string[] = [PATH.DELIVERY_AREA_REFINE];

export const USER_MENU_OPTIONS = [
  { text: '개인정보 관리', value: PATH.VENDER_MODIFY },
  { text: '로그아웃', value: PATH.LOGOUT },
];
